<h2 class="pb-s">Monatsflyer & CSV </h2>
<p>
  Als digitale Ergänzung stellen wir Ihnen den Monatsflyer, sowie die CSV-Datei zur Rabattstufe für die Artikel der Monatsaktion zur Verfügung.
</p>
  <div class="mt-s">
    <div class="row">
      <div class="col-md-7 align-items-center d-flex">
        <a
           target="_blank">Flyer PDF März 2025</a>
      </div>
      <div class="col-md align-items-center d-flex">
        <a class="download-button btn btn-primary btn-round"
           target="_blank">
          <span class="arrow-helper far fa-arrow-down"></span>
        </a>
      </div>
    </div>
  </div>

  <div class="mt-s">
    <div class="row">
      <div class="col-md-7 align-items-center d-flex">
        <a target="_blank">Preise CSV März 2025</a>
      </div>
      <div class="col-md align-items-center d-flex">
        <a class="download-button btn btn-primary btn-round"
           target="_blank">
          <span class="arrow-helper far fa-arrow-down"></span>
        </a>
      </div>
    </div>
  </div>
  <div>
    <h3 class="mt-xl">Plakate für Ihre Screens</h3>
    <div class="row mt-s mb-xxl">
      <div class="col-md-4">
        <div class="align-items-center d-flex">
          <a target="_blank">
            <img src="../../assets/dummy/Plakat-2025-03-RS1-quer-1.jpg" class="image-shadow">
            <span>Plakat Quer März 2025 Seite 1</span></a>
        </div>
      </div>
      <div class="col-md-4">
        <div class="align-items-center d-flex">
          <a target="_blank">
            <img src="../../assets/dummy/Plakat-2025-03-RS1-quer-2.jpg"  class="image-shadow">
            <span>Plakat Quer März 2025 Seite 2</span></a>
        </div>
      </div>
    </div>
    <div class="row mt-l mb-xl">
      <div class="col-md-4">
        <div class="align-items-center d-flex">
          <a target="_blank">
            <img src="../../assets/dummy/Plakat-2025-03-RS1-hoch-1.jpg"  class="image-shadow">
            <span>Plakat Hoch März 2025 Seite 1</span></a>
        </div>
      </div>
      <div class="col-md-4">
        <div class="align-items-center d-flex">
          <a target="_blank">
            <img src="../../assets/dummy/Plakat-2025-03-RS1-hoch-2.jpg"  class="image-shadow">
            <span>Plakat Hoch März 2025 Seite 2</span></a>
        </div>
      </div>
    </div>
  </div>


<h2 class="mt-xxl pb-s">
  Monatsfolder
</h2>
<p>
  Als optimale Ergänzung zu jeder Monatsaktion steht Ihnen zur Produktübersicht unser Monatsfolder in digitaler Form
  zur Verfügung.
</p>
<div class="row mt-s">
  <div class="col-md-2">
    <a target="_blank">
      <img src="../../assets/dummy/Monatsfolder%20März%202025.jpg" class="img-border"/>
    </a>
  </div>
  <div class="col-md align-items-center d-flex">
    <a target="_blank">Monatsfolder März 2025</a>&nbsp; (8,98 MB)
  </div>
  <div class="col-md align-items-center d-flex">
    <a class="download-button btn btn-primary btn-round"
       target="_blank">
      <span class="arrow-helper far fa-arrow-down"></span>
    </a>
  </div>
</div>
<div class="row mt-s">
  <div class="col-md-2">
    <a  target="_blank">
      <img src="../../assets/dummy/Monatsfolder%20Februar%202025.jpg" class="img-border"/>
    </a>
  </div>
  <div class="col-md align-items-center d-flex">
    <a   target="_blank">Monatsfolder Februar 2025</a>&nbsp; (11,73 MB)
  </div>
  <div class="col-md align-items-center d-flex">
    <a class="download-button btn btn-primary btn-round"
       target="_blank">
      <span class="arrow-helper far fa-arrow-down"></span>
    </a>
  </div>
</div>
